import Nullstack from 'nullstack';
export default function IconChartHistogram({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-chart-histogram",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 3v18h18"
  }), "   ", Nullstack.element("path", {
    d: "M20 18v3"
  }), "   ", Nullstack.element("path", {
    d: "M16 16v5"
  }), "   ", Nullstack.element("path", {
    d: "M12 13v8"
  }), "   ", Nullstack.element("path", {
    d: "M8 16v5"
  }), "   ", Nullstack.element("path", {
    d: "M3 11c6 0 5 -5 9 -5s3 5 9 5"
  }), " ");
}